import React, { useState } from "react";
import { Form, Container, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";
import { compressAndUpload } from "../../Helpers/Utils/photoUpload";
// import WastedTerminalSticker from "./WastedTerminalSticker";

function TerminalStickeringDetails({ details, handleChange, errors, navigation }) {

    const [isUploading, setIsUploading] = useState(false);

    // ADD THIS:
    const handlePhotoChange = async (e, fieldName) => {
      const file = e.target.files[0];
      if (!file) return;

      if (file.size > 5 * 1024 * 1024) {
        toast.error("Photo exceeds 5MB limit. Please retake the photo.", {
          autoClose: 3000, hideProgressBar: true, theme: "colored"
        });
        e.target.value = '';
        return;
      }

      setIsUploading(true);
      try {
        const uploadResult = await compressAndUpload(file);
        if (!uploadResult.success) {
          toast.error(uploadResult.error || "Upload failed. Please try again.");
          e.target.value = '';
          return;
        }
        handleChange({
          target: {
            name: `${fieldName}_temp_path`,
            value: uploadResult.temp_path,
            type: 'text'
          }
        });
      } catch (error) {
        toast.error("Error uploading photo");
      } finally {
        setIsUploading(false);
      }
    };

    // Validation function for terminal stickering details
  const validate = () => {
    const newErrors = {
      no_of_stickered: !details.no_of_stickered,
      p1_front_before_photo: !details.p1_front_before_photo_temp_path,
      p1_back_before_photo: !details.p1_back_before_photo_temp_path,
      p1_front_after_photo: !details.p1_front_after_photo_temp_path,
      p1_back_after_photo: !details.p1_back_after_photo_temp_path,
      is_sticker_wasted: !details.is_sticker_wasted,
    };

    const hasErrors = Object.values(newErrors).some(Boolean);
    if (hasErrors) {
      toast.error("Please fill in all required fields", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };
    

  const handleNext = () => {
    if (!validate()) return;
    if (details.is_sticker_wasted === 'Yes') {
      // Make sure a step with id 'wasted-terminal-sticker' exists in SwitchForm.js
      navigation.go('wasted-terminal-sticker');
    } else {
      navigation.go('thermal-roll');
    }
  };

  const handleBack = () => {
    navigation.previous();
  };

      const isFormValid = () => {
      return details.no_of_stickered &&
            details.p1_front_before_photo_temp_path &&
            details.p1_back_before_photo_temp_path &&
            details.p1_front_after_photo_temp_path &&
            details.p1_back_after_photo_temp_path &&
            details.is_sticker_wasted;
    };


  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">

          {/* Main Form */}
          <Col md={10}>

              <div className="form-main-header">
                <h4 className="form-title">TERMINAL STICKERING DETAILS</h4>
                <p className="form-desc">Please provide terminal stickering information</p>
              </div>
               <div className="form-main">
              <div className="form-main-content">
              {/* No. of terminals stickered */}
              <Form.Group className="mb-4">
                <Form.Label className="form-label">
                  No. of terminals stickered <span className="form-required">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="no_of_stickered"
                  value={details.no_of_stickered || ''}
                  onChange={handleChange}
                  placeholder="Short answer text"
                  isInvalid={errors.no_of_stickered}
                />
                {errors.no_of_stickered && (
                  <div className="form-error">Required</div>
                )}
                <div>
                  <p className="form-note-text">
                    <em>"Note: Terminal must be open to check if Maya terminal or not."</em>
                  </p>
                </div>
              </Form.Group>

              {/* P1 front photo (BEFORE STICKERING) */}
              <Form.Group className="mb-4">
                <Form.Label className="form-label">
                  P1 front photo (BEFORE STICKERING) <span className="form-required">*</span>
                  {details.p1_front_before_photo_temp_path && !isUploading && (
                    <span style={{ marginLeft: '10px', color: '#28a745' }}>✅ Uploaded</span>
                  )}
                </Form.Label>
                <Form.Text className="form-hint">Terminal must be open before picturing</Form.Text>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(e) => handlePhotoChange(e, 'p1_front_before_photo')}
                  isInvalid={errors.p1_front_before_photo}
                  disabled={isUploading}
                />
                {isUploading && <div style={{ color: '#007bff', fontSize: '13px', marginTop: '6px' }}>⏳ Uploading...</div>}
                {errors.p1_front_before_photo && <div className="form-error">Required</div>}
              </Form.Group>

              {/* P1 back photo (BEFORE STICKERING) */}
              <Form.Group className="mb-4">
                <Form.Label className="form-label">
                  P1 back photo (BEFORE STICKERING) <span className="form-required">*</span>
                  {details.p1_back_before_photo_temp_path && !isUploading && (
                    <span style={{ marginLeft: '10px', color: '#28a745' }}>✅ Uploaded</span>
                  )}
                </Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(e) => handlePhotoChange(e, 'p1_back_before_photo')}
                  isInvalid={errors.p1_back_before_photo}
                  disabled={isUploading}
                />
                {isUploading && <div style={{ color: '#007bff', fontSize: '13px', marginTop: '6px' }}>⏳ Uploading...</div>}
                {errors.p1_back_before_photo && <div className="form-error">Required</div>}
              </Form.Group>

              {/* P1 front photo (AFTER STICKERING) */}
              <Form.Group className="mb-4">
                <Form.Label className="form-label">
                  P1 front photo (AFTER STICKERING) <span className="form-required">*</span>
                  {details.p1_front_after_photo_temp_path && !isUploading && (
                    <span style={{ marginLeft: '10px', color: '#28a745' }}>✅ Uploaded</span>
                  )}
                </Form.Label>
                <Form.Text className="form-hint">Terminal must be open before picturing</Form.Text>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(e) => handlePhotoChange(e, 'p1_front_after_photo')}
                  isInvalid={errors.p1_front_after_photo}
                  disabled={isUploading}
                />
                {isUploading && <div style={{ color: '#007bff', fontSize: '13px', marginTop: '6px' }}>⏳ Uploading...</div>}
                {errors.p1_front_after_photo && <div className="form-error">Required</div>}
              </Form.Group>

              {/* P1 back photo (AFTER STICKERING) */}
              <Form.Group className="mb-4">
                <Form.Label className="form-label">
                  P1 back photo (AFTER STICKERING) <span className="form-required">*</span>
                  {details.p1_back_after_photo_temp_path && !isUploading && (
                    <span style={{ marginLeft: '10px', color: '#28a745' }}>✅ Uploaded</span>
                  )}
                </Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(e) => handlePhotoChange(e, 'p1_back_after_photo')}
                  isInvalid={errors.p1_back_after_photo}
                  disabled={isUploading}
                />
                {isUploading && <div style={{ color: '#007bff', fontSize: '13px', marginTop: '6px' }}>⏳ Uploading...</div>}
                {errors.p1_back_after_photo && <div className="form-error">Required</div>}
              </Form.Group>
                 {/* Wasted terminal sticker */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Wasted terminal sticker <span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-radio-group">
                      <div className={`form-radio-item${details.is_sticker_wasted === 'Yes' ? " selected" : ""}`}>
                        <div className="form-radio-flex">
                          <Form.Check
                            type="radio"
                            name="is_sticker_wasted"
                            value="Yes"
                            label="Yes"
                            checked={details.is_sticker_wasted === 'Yes'}
                            onChange={handleChange}
                            className="form-radio"
                          />
                        </div>
                      </div>
                      <div className={`form-radio-item${details.is_sticker_wasted === 'No' ? " selected" : ""}`}>
                        <div className="form-radio-flex">
                          <Form.Check
                            type="radio"
                            name="is_sticker_wasted"
                            value="No"
                            label="No"
                            checked={details.is_sticker_wasted === 'No'}
                            onChange={handleChange}
                            className="form-radio"
                          />
                        </div>
                      </div>
                    </div>
                    {errors.is_sticker_wasted && (
                      <div className="form-error">Required</div>
                    )}
                  </Form.Group>
                {/* Navigation Buttons */}
                <div className="form-btn-row">
                  <AppButton
                    onClick={handleBack}
                    variant="back"
                    className="form-btn variant-secondary"
                  >
                    ← Back 
                  </AppButton>
                  <AppButton
                    onClick={handleNext}
                    variant="next"
                    className="form-btn variant-primary"
                  >
                     Next →
                  </AppButton>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default TerminalStickeringDetails;
